import React from 'react';
const CustomProductContext = React.createContext();
export default CustomProductContext;